/**
 * Component for displaying the selected product tiles and details in tabular form for comparison
 */

import vxProductTileVertical from '../vx-product-tile-vertical/vx-product-tile-vertical.vue';
import vxCompareTable from '../vx-compare-table/vx-compare-table.vue';
import {
  eventBus,
} from '../../../modules/event-bus';
import globals from '../../common/globals';
import cookiesMixin from '../../common/mixins/cookies-mixin';
import SearchBrowseService from '../../common/services/search-browse-service';
import mobileMixin from '../../common/mixins/mobile-mixin';

export default {
  name: 'vx-compare-result-page',
  components: {
    vxProductTileVertical,
    vxCompareTable,
  },
  props: {
    /**
     * Copy text coming from properties files
     */
    i18n: {
      type: Object,
    },
    /**
     * indicates whether to show remove option on the product tile
     */
    showRemoveOption: {
      type: Boolean,
      default: false,
    },
    /**
     * indicates whether the site is configured for favorites
     */
    isFavorites: {
      type: Boolean,
      default: false,
    },
    /**
     * indicates whether the site is configured for Bazaar Voice
     */
    isBazaarVoice: {
      type: String,
      default: '',
    },
    /**
     * page type is the type of the page passed as a parameter for get compare results service call
     */
    pageType: {
      type: String,
      default: '',
    },
    /**
     * indicates whether to show title
     */
    showTitle: {
      type: Boolean,
      default: true,
    },
    /**
     * array of product ids selected for comparison
     */
    pdpCompareIds: {
      type: Array,
    },
  },
  mixins: [cookiesMixin, mobileMixin],
  data() {
    return {
      globals,
      productsCompareData: {},
      showRemoveButton: true,
      comparedProducts: null,
      searchBrowseService: new SearchBrowseService(),
    };
  },
  async mounted() {
    this.onInitCheck();
  },
  methods: {
    /**
     * This function is called on mounted which will read product codes from cookie and call generate a query
     */
    onInitCheck() {
      const self = this;
      let queryString = '';
      // condition to check if component is called from PDP page or search result page.
      if (this.pdpCompareIds && this.pdpCompareIds.length > 0) {
        queryString = self.generateQuery(this.pdpCompareIds);
      } else {
        self.comparedProducts = this.readCookie('CompareCookie');
        if (
          self.comparedProducts &&
          self.comparedProducts !== undefined &&
          self.comparedProducts !== null
        ) {
          self.comparedProducts = JSON.parse(self.comparedProducts);
          self.comparedProducts = self.comparedProducts.map(item => item.code);
          queryString = self.generateQuery(self.comparedProducts);
        } else {
          queryString = window.location.search;
        }
      }
      self.generateUrlRequest(queryString);
    },
    /**
     * This function handles response of get compare results service call
     */
    handleCompareResponse(response) {
      if (this.isMobile()) {
        this.productsCompareData = response.data;
        this.productsCompareData.products = this.productsCompareData.products.slice(0, 2);
      } else {
        this.productsCompareData = response.data;
      }
    },
    /**
     * This function handles error of get compare results service call
     */
    handleCompareError(error) {},
    /**
     * This function generates compare result url
     * @param  {String} query string of product codes selected for comparison
     */
    generateUrlRequest(query) {
      const requestConfig = {};
      const self = this;
      self.searchBrowseService.getCompareResults(
        requestConfig,
        self.handleCompareResponse,
        self.handleCompareError,
        query,
        self.pageType,
      );
    },
    /**
     * This function generates compare result url
     * @param  {String} productCode string of product code to generate the query
     */
    generateQuery(productCode) {
      const initialText = '?productCodes=';
      const prodList = initialText + productCode.join(':');
      return prodList;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/search-browse/vx-compare-result-page/vx-compare-result-page.js